/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable */
import qs from 'query-string';
import base64 from 'react-native-base64';
import { getCategories, getCategoryBySlug } from '../fake-server/endpoints/categories';
import {
    getDiscountedProducts,
    getFeaturedProducts,
    getLatestProducts,
    getPopularProducts,
    getProductBySlug,
    getProductsList,
    getRelatedProducts,
    getSuggestions, getTopRatedProducts, getSearchProducts,
    getOrderSuccessList
} from '../fake-server/endpoints/products';
import config from '../data/configurations';
import CategoryFilterBuilder from '../fake-server/filters/category';
import CheckFilterBuilder from '../fake-server/filters/check';
import productsData from '../fake-server/database/products';
import RadioFilterBuilder from '../fake-server/filters/range';
import ColorFilterBuilder from '../fake-server/filters/color';
import RangeFilterBuilder from '../fake-server/filters/price';
const shopApi = {
    /**
     * Returns array of categories.
     *
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<Array<object>>}
     */
    getCategories: (options = {}) => {
        return getCategories(options).then((data) => {
            return data;
        });
    },
    /**
     * Returns array of categories.
     *
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<Array<object>>}
     */
    getCategoriesLive: (options = {}) => {
        return getCategories(options).then((data) => {
            return data;
        });
    },
    /**
     * Returns category by slug.
     *
     * @param {string} slug
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<object>}
     */
    getCategoryBySlug: (slug, options = {}) => {

        return getCategoryBySlug(slug, options).then((data) => {
            return data;
        });
    },
    /**
     * Returns category by slug.
     *
     * @param {string} slug
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<object>}
     */
    getCategoryBySlugLive: (slug, options = {}) => {
        const params = { ...options };
        Object.keys(options).forEach((slug) => {
            params[`filter_${slug}`] = options[slug];
        });
        const url = `${config.production.apiUrl}categories?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`)
            .then((response) => response.json());
    },
    /**
     * Returns product.
     *
     * @param {string} slug
     * @return {Promise<object>}
     */
    getProductBySlug: (slug) => {
    const url = `${config.production.apiUrl}allproducts/${slug}`;

    return fetch(url)
        .then((response) => {
        if (!response.ok) {
            throw new Error('Failed to fetch product');
        }
        return response.json();
        });
    },
    /**
     * Returns array of related products.
     *
     * @param {string}  slug
     * @param {object?} options
     * @param {number?} options.limit
     *
     * @return {Promise<Array<object>>}
     */
    getRelatedProducts: (slug, options = {}) => {
        const params = { ...options };
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Return products list.
     *
     * @param {object?} options
     * @param {number?} options.page
     * @param {number?} options.limit
     * @param {string?} options.sort
     * @param {Object.<string, string>?} filters
     *
     * @return {Promise<object>}
     */
    getProductsList: (options = {}, filters = {}) => {

        const params = { ...options };
        Object.keys(filters).forEach((slug) => {
            params[`filter_${slug}`] = filters[slug];
        });
        // const url = `${config.production.apiUrl}search?stock=true&${qs.stringify(params)}`;
        const url = `${config.production.apiUrl}allproducts?stock=true&${qs.stringify(params)}`;
        const productsDef1 = null;

        return fetch(`${url}`).then((response) => response.json());
    },

    /**
     * Return products list.
     *
     * @param {object?} options
     * @param {number?} options.page
     * @param {number?} options.limit
     * @param {string?} options.sort
     * @param {Object.<string, string>?} filters
     *
     * @return {Promise<object>}
     */
    getFilterProductsList: async (options = {}, filters = {}) => {
        const params = { ...options };
        Object.keys(filters).forEach((slug) => {
            params[`filter_${slug}`] = filters[slug];
        });
        const url = `${config.production.apiUrl}allproducts?stock=true&${qs.stringify(params)}`;
        const productsDef1 = null;
        const customfilters = [
            new CategoryFilterBuilder('category', 'Categories'),
            new CheckFilterBuilder('brand', 'Brand'),
            // new RangeFilterBuilder('price', 'Price'),
            //  new RadioFilterBuilder('discount', 'Discount'),
            // new ColorFilterBuilder('color', 'Color'),
        ];

        const items = await fetch(`${url}`).then((response) => response.json())
            .then((result) => {
                console.log('filters', filters);
                customfilters.forEach((filter) => filter.makeItems(result, filters[filter.slug]));
                // Calculate items count for filter values.
                customfilters.forEach((filter) => filter.calc(result, customfilters));
                // Apply filters to products list.
                let list = result;
                if (list) {
                    const page = options.page || 1;
                    const limit = options.limit || 12;
                    const sort = options.sort || 'default';
                    const total = list.length;
                    const pages = Math.ceil(total / limit);
                    const from = (page - 1) * limit + 1;
                    const to = Math.max(Math.min(page * limit, total), from);
                    const start = (page - 1) * limit;
                    const end = start + limit;

                    list = list.slice(start, end);
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve({
                                page,
                                limit,
                                sort,
                                total,
                                pages,
                                from,
                                to,
                                list,
                                filters: customfilters.map((x) => x.build()),
                            });
                        }, 350);
                    });
                }
            }); // productsData.slice(0);
        return items;
    },
    /**
     * Returns array of featured products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getFeaturedProducts: (options = {}) => {
        const params = { ...options };
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Returns array of latest products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getLatestProducts: (options = {}) => {

        const params = { ...options };
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Returns an array of top rated products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getTopRatedProducts: (options = {}) => {
 
        const params = { ...options };
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Returns an array of discounted products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getDiscountedProducts: (options = {}) => {
 
        const params = { ...options };
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Returns an array of most popular products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getPopularProducts: (options = {}) => {
        const params = { ...options };
        const url = `${config.production.apiUrl}popularproducts?stock=true&${qs.stringify(params)}`;

        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Returns search suggestions.
     *
     * @param {string}  query
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getSuggestions: (query, options = {}) => {

        const params = { ...options };

        // Object.keys(filters).forEach((slug) => {
        //     params[`filter_${slug}`] = filters[slug];
        // });
        const url = `${config.production.apiUrl}topproducts?stock=true&${qs.stringify(params)}`;

        return fetch(`${url}`).then((response) => response.json());
    },

    /**
     * Returns search values.
     *
     * @param {string}  query
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getSearchProducts: (query, options = {}) => {

        const params = { ...options };
        const url = `${config.production.apiUrl}searchproducts?stock=true&${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },
    /**
     * Return rate list.
     *
     * @param {object?} data
     *
     * @return {Promise<object>}
     */
    getShippingRates: (data, items) => {
        const qData = {
            accountNumber: config.production.accountNumber,
            originCountryCode: config.production.originCountryCode,
            originPostalCode: config.production.originPostalCode,
            originCityName: config.production.originCityName,
            destinationCountryCode: data.country,
            destinationPostalCode: data.postcode,
            destinationCityName: data.city,
            height: items.height,
            length: items.itemlength,
            width: items.width,
            weight: items.weight,
            plannedShippingDate: new Date().toJSON().slice(0, 10),
            isCustomsDeclarable: false,
            unitOfMeasurement: 'metric',
            requestEstimatedDeliveryDate: true,
        };
        const params = { ...qData };
        const url = `${config.production.apiUrl}shippingRates?${qs.stringify(params)}`;
        return fetch(`${url}`).then((response) => response.json());
    },

    // order success api
    /**
     * Returns product.
     *
     * @param {string} orderId
     * @param {object?} options
     */
    
    getOrderSuccessList: (options = {}) => {
        return fetch("http://localhost:5000/orderDetails.json").then(response => response.json())
            .then(data => {
                // console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    },
};

export default shopApi;
